import React, { useEffect, useRef, useState } from "react"
import { connect, useSelector, useDispatch } from "react-redux"
import classnames from "classnames"
import { setBreadcrumbItems } from "../../store/actions"
import SimpleBar from "simplebar-react/dist"
import user2 from "../../assets/images/users/user-2.jpg"
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Input,
} from "reactstrap"
import { Link } from "react-router-dom"
import Spinners from "components/Common/Spinner"
import axios from "axios"

const Chat = props => {
  const [facebookChats, setFacebookChats] = useState(null)
  const dispatch = useDispatch()
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  const [messagesData, setMessagesData] = useState([])
  const [currentRoomId, setCurrentRoomId] = useState(null)
  const [Chat_Box_User_Status, setChat_Box_User_Status] = useState("Available")
  const [Chat_Box_Username, setChat_Box_Username] = useState(null)
  const [Chat_Box_Image, setChat_Box_Image] = useState(user2)
  const [loading, setLoading] = useState(false)
  const [curMessage, setCurMessage] = useState("")
  const [pageDetails, setPageDetails] = useState(null)
  const [isDisable, setDisable] = useState(false)
  const mode = useSelector(state => state.Layout.layoutMode)

  const scrollRef = useRef(null)

  // Auto-scroll to bottom when messages change
  useEffect(() => {
    if (scrollRef.current) {
      const scrollElement = scrollRef.current.getScrollElement()
      scrollElement.scrollTop = scrollElement.scrollHeight
    }
  }, [messagesData])

  // Fetch page details first
  useEffect(() => {
    fetchPageDetails()
  }, [])

  // Fetch chats only after pageDetails are loaded
  useEffect(() => {
    if (pageDetails) {
      fetchChats()

      const interval = setInterval(() => {
        fetchChats({ silent: true })
      }, 60000)

      return () => clearInterval(interval)
    }
  }, [pageDetails])

  // Fetch page details
  const fetchPageDetails = async () => {
    try {
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization.FacebookIntegrations[0].pageId}?fields=name,about,attire,bio,location,parking,hours,emails,website,instagram_business_account,picture&access_token=${activeOrganization.FacebookIntegrations[0].pageToken}`,
      )
      setPageDetails(response.data)
    } catch (err) {
      console.log(err)
      props.setErr("Error fetching page details.")
    }
  }

  // Fetch chats
  const fetchChats = async ({ silent = false } = {}) => {
    try {
      const response = await axios.get(
        `https://graph.facebook.com/v20.0/${activeOrganization.FacebookIntegrations[0].pageId}/conversations`,
        {
          params: {
            access_token: activeOrganization.FacebookIntegrations[0].pageToken,
            fields:
              "id,from{name,picture},to,message,messages{message,from{name,picture,id},created_time},updated_time",
          },
          skipLoader: silent,
        },
      )

      const chats = response.data.data
      setFacebookChats(chats)
      console.log("Fetched chats:", chats)

      // Default: select first chat
      if (chats.length > 0) {
        const firstChat = chats[0]
        setMessagesData(firstChat.messages.data)
        setCurrentRoomId(firstChat.id)
        setChat_Box_User_Status("Available")

        const userName =
          firstChat.messages.data.find(
            message => message.from.name !== pageDetails?.name,
          )?.from.name || "Unknown User"

        setChat_Box_Username(userName)
      }
    } catch (err) {
      console.log(err)
      props.setErr("Error fetching chats.")
    }
  }

  // When a user selects a chat
  const userChatOpen = chat => {
    const userName =
      chat.messages.data.find(
        message => message.from.name !== pageDetails?.name,
      )?.from.name || "Unknown User"

    setChat_Box_Username(userName)
    setChat_Box_Image(user2)
    setCurrentRoomId(chat.id)
    setMessagesData(chat.messages.data)
  }

  // Send message
  const sendMessage = async () => {
    if (!curMessage || !currentRoomId) return

    const recipientId = messagesData.find(
      message => message.from.name !== pageDetails?.name,
    )?.from.id

    try {
      const response = await axios.post(
        `https://graph.facebook.com/v20.0/me/messages`,
        {
          recipient: { id: recipientId },
          message: { text: curMessage },
          tag: "POST_PURCHASE_UPDATE",
        },
        {
          headers: {
            Authorization: `Bearer ${activeOrganization.FacebookIntegrations[0].pageToken}`,
          },
        },
      )

      if (response.status === 200) {
        const newMessage = {
          message: curMessage,
          from: {
            name: `${pageDetails?.name}`,
            picture: { data: { url: user2 } },
          },
          created_time: new Date().toISOString(),
        }
        setMessagesData([...messagesData, newMessage])
        setCurMessage("")
        setDisable(false)
      }
    } catch (err) {
      console.log(err)
      props.setErr("Error sending message.")
    }
  }

  return (
    <React.Fragment>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
        <div className="w-100 user-chat">
          <Card className="br" style={{ display: "flex", flexDirection: "row", height: "80vh" }}>
            
            {/* LEFT SIDEBAR */}
            <div className="chat-leftsidebar-nav" style={{ width: "30%", minWidth: "280px" }}>
              <div className="pt-3">
                <div className="px-3">
                  <h5 className="font-size-14 mb-3">
                    Conversations ({facebookChats?.length || 0})
                  </h5>
                </div>

                <ul className="list-unstyled chat-list p-3" style={{ margin: 0 }}>
                  {loading ? (
                    <Spinners setLoading={setLoading} />
                  ) : (
                    <SimpleBar style={{ maxHeight: "70vh" }}>
                      {facebookChats?.map(chat => {
                        const userName =
                          chat.messages.data.find(
                            message => message.from.name !== pageDetails?.name,
                          )?.from.name || "Unknown User"

                        return (
                          <li
                            key={chat.id}
                            className={`p-2 rounded mb-2 ${
                              currentRoomId === chat.id ? "bg-light active" : "hover"
                            }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => userChatOpen(chat)}
                          >
                            <div className="d-flex align-items-center">
                              <div className="flex-shrink-0 me-3">
                                <img
                                  src={chat.image || user2}
                                  className="rounded-circle"
                                  alt=""
                                  width={40}
                                  height={40}
                                />
                              </div>
                              <div className="flex-grow-1 overflow-hidden">
                                <h6 className="text-truncate mb-0">{userName}</h6>
                                <small className="text-muted text-truncate d-block">
                                  {chat.messages.data[0]?.message}
                                </small>
                              </div>
                            </div>
                          </li>
                        )
                      })}
                    </SimpleBar>
                  )}
                </ul>
              </div>
            </div>

            {/* RIGHT CHAT AREA */}
            <div
              style={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                padding: "10px",
              }}
            >
              <div
                className="chat-right-area"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  backgroundColor: mode === "dark" ? "transparent" : "#FAFBFD",
                  borderRadius: "20px",
                  boxShadow:
                    mode === "dark"
                      ? "0px 2px 6px rgba(0,0,0,0.5)"
                      : "0px 2px 6px rgba(0,0,0,0.1)",
                  overflow: "hidden",
                }}
              >
                {/* Header */}
                <div
                  className="p-3 border-bottom d-flex align-items-center"
                  style={{
                    flexShrink: 0,
                    backgroundColor: mode === "dark" ? "transparent" : "#FAFBFD",
                  }}
                >
                  <img
                    src={Chat_Box_Image}
                    alt=""
                    className="rounded-circle me-3"
                    style={{
                      objectFit: "cover",
                      border:
                        mode === "dark"
                          ? "2px solid #363F4F"
                          : "2px solid #F1F1F1",
                    }}
                    width={45}
                    height={45}
                  />
                  <div>
                    <h5
                      style={{ color: mode === "dark" ? "#fff" : "#000" }}
                      className="mb-0"
                    >
                      {Chat_Box_Username || "Select a conversation"}
                    </h5>
                    <small
                      style={{ color: mode === "dark" ? "#fff" : "#2990DF" }}
                    >
                      {Chat_Box_User_Status}
                    </small>
                  </div>
                </div>

                {/* Chat messages */}
                <div style={{ flexGrow: 1, overflowY: "auto", padding: "1rem", minHeight: 0 }}>
                  <SimpleBar
                    style={{
                      height: "100%",
                      color: mode === "dark" ? "#EDEDED" : "#000",
                      transition: "background-color 0.3s ease, color 0.3s ease",
                    }}
                    ref={scrollRef}
                  >
                    {loading ? (
                      <Spinners setLoading={setLoading} />
                    ) : (
                      <ul className="list-unstyled mb-0">
                        {messagesData &&
                          [...messagesData]
                            .sort(
                              (a, b) =>
                                new Date(a.created_time) - new Date(b.created_time),
                            )
                            .map((messageDat, index) => {
                              const isMe = messageDat?.from?.name === pageDetails?.name

                              const bubbleBg =
                                mode === "dark"
                                  ? isMe
                                    ? "#22384F"
                                    : "#404854"
                                  : isMe
                                  ? "#DDECF9"
                                  : "#FFFFFF"

                              const textColor =
                                mode === "dark"
                                  ? "#fff"
                                  : "#000000"

                              const timeColor =
                                mode === "dark" ? "#B0BEC5" : "#6c757d"

                              return (
                                <li
                                  key={index}
                                  className={`mb-3 d-flex ${
                                    isMe ? "justify-content-end" : "justify-content-start"
                                  }`}
                                >
                                  <div
                                    className="p-2 rounded"
                                    style={{
                                      maxWidth: "70%",
                                      backgroundColor: bubbleBg,
                                      color: textColor,
                                      border:
                                        mode === "dark"
                                          ? "none"
                                          : "1px solid #dee2e6",
                                    }}
                                  >
                                    <p className="mb-1">{messageDat?.message || ""}</p>
                                    <small style={{ color: timeColor }}>
                                      {new Date(messageDat?.created_time).toLocaleTimeString(
                                        "en-US",
                                        {
                                          hour: "numeric",
                                          minute: "numeric",
                                          hour12: true,
                                        },
                                      )}
                                    </small>
                                  </div>
                                </li>
                              )
                            })}
                      </ul>
                    )}
                  </SimpleBar>
                </div>

                {/* Input box */}
                <div
                  className="p-3"
                  style={{
                    flexShrink: 0,
                    backgroundColor: mode === "dark" ? "transparent" : "#FAFBFD",
                    borderRadius: "0 0 20px 20px",
                  }}
                >
                  <Row>
                    <Col>
                      <Input
                        type="text"
                        value={curMessage}
                        onChange={e => setCurMessage(e.target.value)}
                        placeholder="Enter message..."
                        onKeyPress={e => {
                          if (e.key === "Enter" && curMessage && !isDisable) {
                            sendMessage()
                          }
                        }}
                      />
                    </Col>
                    <Col className="col-auto">
                      <Button
                        type="button"
                        onClick={sendMessage}
                        disabled={!curMessage || isDisable}
                        style={{
                          backgroundColor:
                            !curMessage || isDisable ? "#6c757d" : "#2990DF",
                          color: !curMessage || isDisable ? "#B0BEC5" : "#fff",
                          borderColor: "none",
                        }}
                      >
                        Send <i className="mdi mdi-send ms-1"></i>
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => {
  return {}
}

export default connect(mapStateToProps, { setBreadcrumbItems })(Chat)
